<template>
  <div>
    <v-list-tile class="default-class highlight" @click.stop="dialog = true">
      <v-list-tile-action>
        <v-icon>logout</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t('rms.logout') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <ConfirmationDialog
      v-if="dialog"
      :dialog="dialog"
      @confirm="logout()"
      @cancel="dialog = false"
    ></ConfirmationDialog>
  </div>
</template>

<script>
import ConfirmationDialog from '../components/dialogBox/Confirmation';
import {mapGetters, mapState} from 'vuex';

export default {
  name: 'Logout',
  data() {
    return {
      dialog:false
    };
  },
  computed: {
    ...mapState({
      key: state => state.auth.key,
    }),
  },
  components: {
    ConfirmationDialog,
  },
  methods: {
    async logout() {
      try {
        var data = await this.$store.dispatch('auth/logout', {
          key: this.key,
        });
      } catch (error) {
        this.activeRegisterField();
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>
